import { render, staticRenderFns } from "./SysUserPhoneBindModal.vue?vue&type=template&id=bf709a9e&"
import script from "./SysUserPhoneBindModal.vue?vue&type=script&lang=js&"
export * from "./SysUserPhoneBindModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports